import { render, staticRenderFns } from "./GenerateJigModal.vue?vue&type=template&id=4c87ba74"
import script from "./GenerateJigModal.vue?vue&type=script&lang=ts"
export * from "./GenerateJigModal.vue?vue&type=script&lang=ts"
import style0 from "./GenerateJigModal.vue?vue&type=style&index=0&id=4c87ba74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports